var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.open}},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{staticClass:"modal",class:{ 'is-viewing': _vm.isOpen },on:{"click":_vm.close}},[_c('div',{ref:"modal",staticClass:"modal-inner",on:{"click":function($event){$event.stopPropagation();_vm.close($event)}}},[_c('div',{staticClass:"video"},[_vm._t("body")],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-screen",on:{"click":_vm.close}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff35b20","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Video.vue
// module id = null
// module chunks = 